import React, { createContext, useContext, useMemo, useState } from "react";

const LocationFeeContext = createContext(null);

export function LocationFeeProvider({ children }) {
  // ✅ Ton point de départ fixe (à modifier)
  const [origin] = useState({
    lat: 6.1493293549864205,
    lng: 1.2011058223361772,
    label: "Point de départ",
  });

  const [userPos, setUserPos] = useState(null);
  const [distanceKm, setDistanceKm] = useState(null);
  const [deliveryFee, setDeliveryFee] = useState(0);

  const value = useMemo(
    () => ({
      origin,
      userPos,
      setUserPos,
      distanceKm,
      setDistanceKm,
      deliveryFee,
      setDeliveryFee,
    }),
    [origin, userPos, distanceKm, deliveryFee]
  );

  return <LocationFeeContext.Provider value={value}>{children}</LocationFeeContext.Provider>;
}

export function useLocationFee() {
  const ctx = useContext(LocationFeeContext);
  if (!ctx) throw new Error("useLocationFee must be used within <LocationFeeProvider />");
  return ctx;
}